document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the class `mobile-menu-item`
  const menuItems = document.querySelectorAll('.mobile-nav li a');
  const backButtons = document.querySelectorAll('.back-button');

  menuItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      const check_mobile_url = item.getAttribute('href');
      if(check_mobile_url == "#" || check_mobile_url =='/fr-fr#' ){
        event.preventDefault();
        item.parentNode.classList.add('active');
      } 
    });
  });
  // Handle back button click
  backButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      // Hide the current submenu
      const currentSubNav = button.closest('li.active');
      currentSubNav.classList.remove('active');
    });
  });
});
